<!--
 * @Date: 2021-08-19 13:49
 * @LastEditTime: 2021-08-19 13:49
 * @Description: 服务详情
 * @FilePath: \shangwu_web\src\views\services\servicesView\servicesInfo.vue
-->
<template>
  <div class="servicesInfo">
    <web-head :active="tab" @change="changeTab"></web-head>
    <div class="background type-page">
      <article class="contain flex-column-center">
        <section class="location">
          <span
            >您现在的位置是：<span
              @click="navPosition('home')"
              class="navPosition"
              >首页</span
            >>
            <span @click="navPosition('Services')" class="navPosition"
              >供需对接</span
            >> 需求详情</span
          >
        </section>
        <section class="servicesInfos">
          <div
            class="servicesTitle"
            v-html="showcontent(serverInfo.title)"
          ></div>
          <div class="servicesContent">
            <div class="servicesContent-title">
              <span></span>
              需求详情
            </div>
            <div class="servicesContent-news">
              <div>需求预算(元): <span></span>面议</div>
              <div>
                需求类别:
                <p v-html="showcontent(serverInfo.type)">LOGO设计</p>
              </div>
              <div>
                需求描述:
                <p v-html="showcontent(serverInfo.description)"></p>
              </div>
            </div>
          </div>
          <div class="getServices" v-if="!this.vid">
            <el-button type="primary" @click="getdemand">承接需求</el-button>
          </div>
        </section>
      </article>
    </div>
    <web-foot></web-foot>
  </div>
</template>

<script scoped>
import Head from "@wigets/head.vue";
import Foot from "@wigets/foot.vue";
import { demandInfo, undertake } from "@apis/apis";
import { showcontent } from "@utils/method.js";

export default {
  name: "detailPages",
  data() {
    return {
      tab: 2,
      id: "",
      vid: "",
      serverInfo: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.vid = this.$route.query.d;
    this.getserveInfo();
  },
  methods: {
    showcontent,
    //进入页面获取到需求信息
    getserveInfo() {
      let id = this.$route.query.id;
      if (!id) {
        this.$router.push({ name: "home" });
      }
      this.$ajaxGet(`${demandInfo}/${id}`, {})
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          }
          this.serverInfo = res.data.data;
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
            callback: () => {
              location.reload();
            },
          });
        });
    },
    //点击位置导航进行跳转
    navPosition(name) {
      this.$router.push({ name });
      this.$nextTick(() => {
        window.scrollTo(0, 1910);
      });
    },
    //承接需求
    getdemand() {
      let login = sessionStorage.getItem("user-login");
      if (!login) {
        this.$message({
          type: "error",
          title: "请先登录",
          message: "您还未登录，请先登录",
        });
        return;
      }
      const { userType, enterpriseId } = JSON.parse(
        sessionStorage.getItem("user-login")
      );
      if (userType === 3) return this.$message.error("请以企业身份承接需求!");
      this.$ajaxGet(`${undertake}?id=${this.id}&&companyId=${enterpriseId}`, {})
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          } else {
            this.$message.success("承接成功!");
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          }
          console.log(res);
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
            callback: () => {
              location.reload();
            },
          });
        });
    },
    changeTab(val) {
      this.tab = val;
    },
  },

  components: {
    "web-head": Head,
    "web-foot": Foot,
  },
};
</script>

<style lang="less" scoped>
@primary_color_1: #4878b3;
@media all and (min-width: 750px) {
  .servicesInfo {
    width: 100%;
    .background {
      background-color: #f2f2f2;
      padding-bottom: 0.5rem;
    }

    .contain {
      width: 100%;
      position: relative;
      section {
        width: 100%;
        margin-top: 0.2rem;
      }

      .location {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-size: 0.14rem;
        letter-spacing: 0rem;
        color: #aaaaaa;
      }
    }
    .servicesInfos {
      width: 100%;
      background: #fff;
      padding: 0.2rem;
      box-sizing: border-box;
      .servicesTitle {
        height: 0.5rem;
        line-height: 0.5rem;
        font-size: 0.24rem;
        text-align: left;
      }
      .servicesContent {
        box-shadow: 0rem 0.03rem 0.15rem 0rem rgba(77, 150, 242, 0.35);
        padding-bottom: 0.2rem;
        .servicesContent-title {
          font-size: 0.2rem;
          text-align: left;
          height: 0.5rem;
          padding: 0.2rem;
          display: flex;
          align-items: center;
          span {
            height: 0.35rem;
            display: inline-block;
            width: 0.05rem;
            border-radius: 0.05rem;
            background-color: #91bef9;
            margin: 0 0.1rem;
          }
        }
        .servicesContent-news {
          font-size: 0.2rem;
          text-align: left;
          padding-left: 0.5rem;
          div {
            margin-bottom: 0.2rem;
          }
          p {
            margin: 0;
            padding-left: 0.2rem;
            margin-top: 0.1rem;
          }
        }
      }
      .getServices {
        display: flex;
        justify-content: flex-start;
        margin-top: 0.3rem;
      }
      /deep/.el-button {
        width: 3rem;
        height: 0.5rem;
        font-size: 0.2rem;
        color: #fff;
        margin: 0.4rem 0 0.2rem 0;
        border-radius: 0.1rem;
        margin: 0;
        padding: 0;
        display: flex;
        span {
          height: 0.5rem;
          width: 3rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  @media screen and (max-width: 750px) {
  }
}
</style>